import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { FormProvider } from "@/context/FormContext";
import SmartForm from "@/components/SmartForm";
import Landing from "@/pages/Landing";
import LegalPage from "@/pages/LegalPage";
import AdminInbox from "@/pages/AdminInbox";
import Academy from "@/pages/Academy";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/") document.title = "FundAI | AI Venture Development, Funding Access and Commercialisation";
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App min-h-screen bg-[#050507] text-[#F4F4F5]">
        <div className="noise-overlay" />
        <BrowserRouter>
          <FormProvider>
            <ScrollManager />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/academy" element={<Academy />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/admin" element={<AdminInbox />} />
            </Routes>
            <SmartForm />
          </FormProvider>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </div>
    </ReactLenis>
  );
}

export default App;
